import cs from "classnames";
import type React from "react";
import type { FC } from "react";

interface ItemProps {
  description: React.ReactNode;
  descriptionClass?: any;
}

export const AmountItem: FC<React.PropsWithChildren<ItemProps>> = (props) => {
  const { children, description, descriptionClass } = props;
  return (
    <div className="flex items-center justify-between p-6 bg-gray-100">
      <span className={cs("font-medium", descriptionClass)}>{description}</span>
      <span>{children}</span>
    </div>
  );
};
